export default function openAuth(context) {
  const {
    host,
    ramblerId: {
      rname,
      useAuthRedirect,
    },
  } = context;

  const authMethod = useAuthRedirect ? 'redirectToAuth' : 'openProviderOAuth';
  const authParams = useAuthRedirect
    ? {
      rname,
      theme: rname,
      back: `https://${host}`,
      path: '/login-20/phone-login',
    } : {
      action: 'login',
      provider: 'sberbank',
      rname,
    };

  window?.ramblerIdHelper[authMethod](authParams);
}
